import { TableCount } from '../interfaces';

export const tableCount = (
  active: boolean = false,
  title: string = '',
): TableCount => ({
  active,
  title,
});
